import type ItemPlacement from 'components/framework/models/ItemPlacement';
import ListDropHandler from 'javascripts/dnd/ListDropHandler';
import type CardLayoutEditorController from '../controllers/CardLayoutEditorController';
import type DraggableDividerRow from './DraggableDividerRow';

class CardRowDropHandler extends ListDropHandler<CardLayoutEditorController> {
  static get accepts() {
    return ['DraggableDividerRow', 'DraggableUiItem'];
  }

  async persistDroppedItems({
    dragItems,
    items,
    placement,
  }: {
    dragItems: DraggableDividerRow[];
    items: any[];
    placement: ItemPlacement;
  }) {
    this.controller.actionDropDividerRow({ items, placement });
  }
}

export default CardRowDropHandler;
